import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const CancelCreditsModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CancelCreditsModalContainer" */
      './CancelCreditsModalContainer'
    ),
  loading: LoadingModal,
});
